module.exports = __webpack_public_path__ + "img/37397-104.9a3095da.jpg";